var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "291px",
    height: "101px",
    viewBox: "0 0 291 101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "final-logo-copy",
    transform: "translate(-242.000000, -187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(243.000000, 189.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2707509,24.0864991 C27.2853891,19.1759753 23.5908697,16.7207134 19.1871929,16.7207134 C17.4373051,16.7207134 11.7548912,16.9201297 7.19527301,24.0864991 C6.47995413,24.8143807 5.24654171,25.933739 0.000303469454,25.933739 C-0.0294764652,25.9336856 6.47995413,27.173633 8.22615597,28.2386851 C9.17515019,28.8902149 16.9626514,32.2461414 12.5944037,46.5894266 C12.322731,47.1729843 6.25153227,63.8997908 24.1230699,66.4776865",
    id: "Path-6-Copy-3",
    stroke: "#ffffff",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8161521,66.5404999 C29.5605572,66.5815008 43.266643,66.7161248 54.5029901,72.5025124 C62.8399325,77.2612184 65.6483756,84.6243157 68.3566577,91.2230968 C68.9286233,92.6167021 70.409536,94.5409256 72.7993956,96.9957675 C70.5950249,97.0488906 68.6972939,96.4545095 67.1062028,95.212624 C63.620267,92.9256164 59.4430253,90.6086368 52.1738199,89.4902447 C48.8180245,88.6130195 45.2022365,88.5821386 35.8995573,82.9414932 C31.3853548,79.7799222 27.4366176,75.3284352 24.9546913,67.6190279",
    id: "Path",
    stroke: "#ffffff",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9087141,66.78782 C24.6102379,65.4826279 24.3473654,64.0984736 24.1230699,62.6288651 C22.9889739,54.7301237 25.4280536,39.4602408 42.3346216,27.0864991 C42.9873597,26.51963 55.2414416,15.9929857 56.4369309,0 C56.5875727,0.284070069 63.0519801,14.2477479 63.2414248,19.7207134 C63.832399,27.6340192 62.3870755,34.1961786 54.5937313,42.7074241 C51.3018893,46.0666278 44.0542213,50.7340418 34.5020047,55.8322795",
    id: "Path-6-Copy-5",
    stroke: "#ffffff",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#ffffff",
    cx: 17.7858598,
    cy: 25.7340418,
    r: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b87cfd9544a196b6cdad8ce82be664d8.svg";
export { ForwardRef as ReactComponent };